import { fetch } from '../utils';

export const createProductUpdatesRepository = () => {
  const fetchUpdates = () => fetch({
    method: 'get',
    path: 'changelog',
    headers: {
      Authorization: localStorage.jwt,
    },
  });

  const fetchUpdatesByType = (type, lastUpdate) => fetch({
    method: 'get',
    path: `changelog/${type}/${lastUpdate}`,
    headers: {
      Authorization: localStorage.jwt,
    },
  });

  const createUpdate = (updateData) => fetch({
    method: 'post',
    path: 'changelog',
    headers: {
      Authorization: localStorage.jwt,
    },
    data: updateData,
  });

  const updateUpdate = (id, updateData) => fetch({
    method: 'put',
    path: `changelog/${id}`,
    headers: {
      Authorization: localStorage.jwt,
    },
    data: updateData,
  });

  const deleteUpdate = (id) => fetch({
    method: 'delete',
    path: `changelog/${id}`,
    headers: {
      Authorization: localStorage.jwt,
    },
  });

  return {
    fetchUpdates,
    fetchUpdatesByType,
    createUpdate,
    updateUpdate,
    deleteUpdate,
  };
}; 